import React, { Fragment, useState } from "react";
import FileViewer from "react-file-viewer";
import FileViewerError from "../../FileViewer/FileViewerError";
import Alert from "./Alert";

const UploadResume = ({
  setShowAddAttachment,
  setAttachmentFile,
  attachmentFile,
  setAttachmentDataFile,
  attachmentDataFile,
  setAttachments,
  attachments,
  setFiles,
  files,
  isAuthenticated,
  user,
  applyIMEResume,
  jobId,
  jobChannelId,
}) => {
  const [docType, setDocType] = useState("docx");
  const [attachmentArrayFile, setAttachmentArrayFile] = useState("");

  return (
    <Fragment>
      <div className="resume-overlay">
        <div className="document-box-resume">
          <i
            className="fas fa-times fa-3x profile-x-dark"
            onClick={() => {
              setAttachmentFile({ file: "", description: "" });
              setAttachmentDataFile("");
              setShowAddAttachment(false);
            }}
          ></i>
          <div className="width-container">
            {attachmentFile.file !== "" ? (
              <p className="attachment-name-light">
                <i className="far fa-folder fa-lg mr-10 black"></i>
                {attachmentFile.file}
              </p>
            ) : (
              <div className="flex-center">
                <p className="attachment-name-light">
                  <i className="far fa-folder fa-lg mr-10 black"></i>Attachment
                  Name
                </p>
              </div>
            )}
            {isAuthenticated &&
              user.resume.professionalsummary !== "" &&
              user.resume.experience.length > 0 &&
              user.resume.education.length > 0 && (
                <div>
                  <div
                    className="create-post-button-container"
                    onClick={() => {}}
                  >
                    <button
                      type="submit"
                      className="create-post-button-resume background-dark-black white"
                      onClick={() => {
                        applyIMEResume(jobId, jobChannelId);
                        setShowAddAttachment(false);
                      }}
                    >
                      <i className="fas fa-file mx-5"></i>Apply with ime Resume
                    </button>
                  </div>
                  <div className="or">
                    <p className="or-line background-dark-black"></p>
                    <p className="or-word black">OR</p>
                    <p className="or-line background-dark-black"></p>
                  </div>
                </div>
              )}
            {isAuthenticated && user.resume.professionalsummary === "" && (
              <label htmlFor="firstname" className="labels-input black bold">
                *Add Professional Summary to apply with ime resume or upload a
                resume below*
              </label>
            )}
            {isAuthenticated && user.resume.experience.length <= 0 && (
              <label htmlFor="firstname" className="labels-input black bold">
                *Add Experience to apply with ime resume or upload a resume
                below*
              </label>
            )}
            {isAuthenticated && user.resume.education.length <= 0 && (
              <label htmlFor="firstname" className="labels-input black bold">
                *Add Education to apply with ime resume or upload a resume
                below*
              </label>
            )}
            <div className="input-label-container">
              <label htmlFor="firstname" className="labels-input black bold">
                *Resume File Type:
              </label>
              <select
                className="job-select"
                name="fileType"
                onChange={(e) => {
                  setDocType(e.target.value);
                  setAttachmentFile({
                    ...attachmentFile,
                    docType: e.target.value,
                  });
                }}
              >
                <option value="docx">docx</option>
                <option value="pdf">pdf</option>
              </select>
            </div>
            {!isAuthenticated && (
              <div className="input-label-container">
                <label htmlFor="email" className="labels-input black bold">
                  *Email:
                </label>
                {attachmentFile.email === "" && <Alert />}
                <input
                  type="email"
                  name="email"
                  required
                  value={attachmentFile.email}
                  className="input-item-light"
                  placeholder="Enter Email Address"
                  onChange={(e) =>
                    setAttachmentFile({
                      ...attachmentFile,
                      email: e.target.value,
                    })
                  }
                />
              </div>
            )}
            <div className="upload-container">
              {attachmentDataFile === "" ? (
                <label
                  htmlFor="profilephotopost"
                  className="setup-image-container"
                >
                  <div className="create-attachment-icons-resume light-grey">
                    <i className="fas fa-plus fa-lg black"></i>
                    <i className="far fa-folder fa-4x mx-5 black"></i>
                  </div>
                </label>
              ) : (
                <div className="document-resume">
                  <FileViewer
                    fileType={docType}
                    filePath={attachmentDataFile}
                    errorComponent={FileViewerError}
                    onError={FileViewerError}
                  />
                </div>
              )}
              <input
                type="file"
                name="profilephotopost"
                id="profilephotopost"
                className="file-upload"
                onChange={(e) => {
                  setAttachmentFile({
                    ...attachmentFile,
                    file: e.target.files[0].name,
                  });
                  setAttachmentDataFile(URL.createObjectURL(e.target.files[0]));
                  setAttachmentArrayFile(e.target.files[0]);
                }}
              />
            </div>
            {attachmentDataFile !== "" && (
              <div
                className="create-post-button-container"
                onClick={() => {
                  setAttachmentFile({ file: "", description: "" });
                  setAttachmentDataFile("");
                }}
              >
                <button
                  type="submit"
                  className="create-post-button background-red"
                >
                  <i className="fas fa-times mx-5"></i>Delete Attachment
                </button>
              </div>
            )}
          </div>
        </div>
        {!isAuthenticated &&
          attachmentFile.file !== "" &&
          attachmentFile.email !== "" && (
            <div
              className="submit-changes"
              onClick={() => {
                setAttachments([...attachments, attachmentFile]);
                setFiles([...files, attachmentArrayFile]);
                setShowAddAttachment(false);
              }}
            >
              <button className="submit-changes-button background-dark-black white">
                Add Resume
              </button>
            </div>
          )}
        {isAuthenticated && attachmentFile.file !== "" && (
          <div
            className="submit-changes"
            onClick={() => {
              setAttachments([...attachments, attachmentFile]);
              setFiles([...files, attachmentArrayFile]);
              setShowAddAttachment(false);
            }}
          >
            <button className="submit-changes-button background-dark-black white">
              Add Resume
            </button>
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default UploadResume;
